module.exports = __webpack_public_path__ + "imgcvh/hero-1.1e265e9a.jpg";